import { Row, Select } from "antd";
import { useState, useEffect } from "react";

const { Option } = Select;

export const SelectCustomResultados = ({
  idCampo,
  nombreCampo,
  arrayOpciones,
  textoOpciones,
  elValue,
  elPlaceholder,
  required,
  tipoError,
  error,
  onChange,
}) => {
  const [selectedValue, setSelectedValue] = useState(elValue || null);
  let esRequired = required ? "*" : "";

  useEffect(() => {
    setSelectedValue(elValue || null);
  }, [elValue]);

  const handleSelectChange = (selectedValue) => {
    setSelectedValue(selectedValue);
    onChange({ target: { value: String(selectedValue), id: idCampo } });
  };

  return (
    <Row justify={"center"}>
      <label htmlFor={idCampo}>
        <p className="nombre-campo">{nombreCampo} {esRequired}</p>
      </label>
      <Select
     className="select-custom select-total-campeonato"
        showSearch
        autoComplete="none"
        key={idCampo + "*" + elValue}
        id={idCampo}
        onChange={handleSelectChange}
        placeholder={elPlaceholder}
        style={{ width: "50em",height:"3em" }}
        required={required}
        value={selectedValue !== null ? String(selectedValue) : undefined}
        filterOption={(input, option) =>
          (option.children || "").toLowerCase().includes(input.toLowerCase())
        }
        status={tipoError}
      >
        <Option key={"vacio"} value="">
          Total campeonato
        </Option>
        {arrayOpciones.map((option) => (
          <Option key={option.id} value={String(option.id)}>
            {option[textoOpciones]}
          </Option>
        ))}
      </Select>
      <span className="spanErrores" style={{ color: "red" }}>
        <b>{error}</b>
      </span>
    </Row>
  );
};